import axios from '@axios'

const PREFIX = 'plataforma/implantacao'

export default {
  listar(page, size, filter) {
    return axios.get(`/${PREFIX}/tenants?page=${page}&size=${size}`, filter)
  },
  listarTemplates() {
    return axios.get(`/${PREFIX}/template-tenants`)
  },
  provisionarTenant(novoCliente) {
    return axios.post(`/${PREFIX}/provisionar-tenant`, novoCliente)
  },
  listarGrupoUsuariosEFuncoesBaseTemplate(baseTemplate) {
    return axios.get(`/${PREFIX}/template-tenants/${baseTemplate}/grupos-funcoes-usuarios-internos`)
  },
}
